module.exports = __webpack_public_path__ + "assets/img/2.b9046a15.jpg";